import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { applicationsService } from "../../services/ApplicationsService";
import { lookupsService } from "../../services/LookupsService";
import { formatDate } from "../../config/Config";
import ViewApplication from "./ViewApplication";
import { InputText } from "primereact/inputtext";

export class ApplicationQuery {
	constructor(pageIndex = 1, pageSize = 10, referenceNumber = null, idNumber = null) {
		this.pageIndex = pageIndex;
		this.pageSize = pageSize;
		if (idNumber) {
			this.idNumber = idNumber;
		}

		if (referenceNumber) {
			this.referenceNumber = referenceNumber;
		}
	}
}

export const ApplicationSearch = () => {
	const toast = useRef(null);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [totalRecords, setTotalRecords] = useState([]);
	const [query, setQuery] = useState(new ApplicationQuery());
	const [lookups, setLookups] = useState({
		applicationStatuses: [],
		applicationTypes: []
	});
	const [selectedItems, setSelectedItems] = useState([]);
	const [application, setApplication] = useState(null);
	const [showApplication, setShowApplication] = useState(false);
	const [selectedType, setSelectedType] = useState(null);
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		referenceNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
		idNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
		applicationDate: { value: null, matchMode: FilterMatchMode.CUSTOM },
		"applicationType.name": { value: null, matchMode: FilterMatchMode.EQUALS },
		"applicationStatus.name": { value: null, matchMode: FilterMatchMode.EQUALS }
	});

	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">Applications</h5>
		</div>
	);

	const columnConfigs = {
		Registration: [{ field: "registration.village.name", header: "Village" }],
		Transfer: [
			{ field: "transfer.fromVillage.name", header: "From Village" },
			{ field: "transfer.toVillage.name", header: "From Village" }
		]
	};

	// Custom filter function for date filtering
	const dateFilter = (value, filter) => {
		if (!filter || !filter.value) return true;
		return new Date(value) >= filter.value;
	};

	const onDateFilterChange = (e) => {
		let newFilters = { ...filters };
		newFilters["applicationDate"].value = e.value;
		setFilters(newFilters);
	};

	const onPageChange = (event) => {
		setQuery(new ApplicationQuery(event.page + 1, event.rows));
	};

	const onHideApplication = () => {
		setShowApplication(false);
		setApplication(null);
	};

	function onSubmitApplication() {
		setShowApplication(false);
		setApplication(null);

		applicationsService
			.getAll(query)
			.then((data) => {
				setLoading(false);
				setData(data.applications);
				setTotalRecords(data.count);
			})
			.catch((error) => {
				console.error("Error fetching application:", error);
				setLoading(false);
			});
	}

	var [searchValue, setSearchValue] = useState("");
	var [searchType, _] = useState([
		{ Id: 2, name: "National ID" },
		{ Id: 1, name: "Reference Number" }
	]);
	var [selectedSearchType, setSelectedSearchType] = useState(searchType[0]);

	const onSearch = () => {
		var _type = selectedSearchType.Id;
		var idNumber = _type == 2 ? searchValue : null;
		var refNumber = _type == 1 ? searchValue : null;
		setLoading(true);
		applicationsService
			.getAll(new ApplicationQuery(0, 10, refNumber, idNumber))
			.then((data) => {
				setLoading(false);
				setData(data.applications);
				setTotalRecords(data.count);
			})
			.catch((error) => {
				console.error("Error fetching application:", error);
				setLoading(false);
			});
	};

	// useEffect(() => {
	// 	//setLoading(true);
	// 	lookupsService
	// 		.getAll()
	// 		.then((data) => {
	// 			//setLoading(false);
	// 			setLookups({
	// 				applicationStatuses: data.applicationStatuses,
	// 				applicationTypes: data.applicationTypes
	// 			});
	// 		})
	// 		.catch((error) => {
	// 			console.error("Error fetching lookups:", error);
	// 			//setLoading(false);
	// 		});
	// }, []);

	return (
		<div className="card  p-align-stretch vertical-container">
			<div className="">
				<Toast ref={toast} />
				<Toolbar
					className="mb-4"
					start={
						<div>
							<span className="block mt-2 md:mt-0 p-input-icon-left">
								<i className="pi pi-search" />
								<InputText placeholder="Search..." onChange={(e) => setSearchValue(e.target.value)} />
								<Dropdown
									className="ml-4"
									style={{display:"none"}}
									value={selectedSearchType}
									options={searchType}
									onChange={(e) => setSelectedSearchType(e.value)}
									optionLabel="name"
								/>
								<Button
									className="p-button-success ml-4"
									label="Search"
									onClick={onSearch}
									disabled={searchValue.trim().length < 11}
								/>
							</span>
						</div>
					}
				></Toolbar>
			</div>

			<DataTable
				size="small"
				scrollable={true}
				value={data}
				loading={loading}
				dataKey="applicationID"
				paginator
				rows={query.pageSize} // Use limit from query model
				totalRecords={totalRecords}
				onPage={onPageChange}
				rowsPerPageOptions={[10, 25, 50]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
				emptyMessage="No data found."
				header={header}
				responsiveLayout="scroll"
				resizableColumns
				columnResizeMode="expand"
				onSelectionChange={(e) => setSelectedItems(e.value)}
				selection={selectedItems}
				selectionPageOnly={true}
				filters={filters}
				globalFilterFields={["referenceNumber", "idNumber", "applicationDate", "applicationType.name", "applicationStatus.name"]}
				// filterDisplay="row"
			>
				<Column field="referenceNumber" header="Reference No." sortable></Column>
				<Column field="idNumber" header="National ID" sortable></Column>
				<Column
					field="applicationDate"
					header="Application Date"
					sortable
					body={(rowData) => formatDate(rowData.applicationDate?.split(" ")[0])}
				/>
				{/* <Column field="applicationChannel.name" header="Channel" sortable /> */}
				<Column field="applicationType" header="Type" sortable />

				<Column field="applicationStatus" header="Status" sortable />

				{columnConfigs[selectedType?.name]?.map((col) => (
					<Column key={col.field} field={col.field} header={col.header} sortable />
				))}

				<Column
					field="actions"
					header="Actions"
					body={(rowData) => (
						<>
							<Button
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-eye"}
								tooltipOptions={{ position: "top" }}
								className="p-button-primary p-button-rounded mr-2"
								tooltip="Click to View"
								onClick={() => {
									setApplication(rowData);
									setShowApplication(true);
								}}
							/>
						</>
					)}
				></Column>
			</DataTable>

			{application && (
				<ViewApplication
					applicationID={application?.applicationID}
					referenceNumber={application?.referenceNumber}
					applicationTypeID={application?.applicationType?.applicationTypeID}
					idNumber={application?.idNumber}
					visible={showApplication}
					onHide={onHideApplication}
					onSubmit={onSubmitApplication}
				/>
			)}
		</div>
	);
};
